import { useEffect } from 'react';

/**
 * Calls the close callback when the container is resized.
 */
export var useCloseOnResize = function useCloseOnResize(options) {
  var node = options.node,
      onClose = options.onClose;
  useEffect(function () {
    if (!node) {
      return;
    } // Close the overlay when the user resize the window


    window.addEventListener('resize', onClose, false);
    return function () {
      window.removeEventListener('resize', onClose, false);
    };
  }, [node, onClose]);
};